import React from "react";
import { CloseableArea } from "../../components/closeableArea";
import { MenuContainer } from "./style";

export const Menu = props => {
  return (
    <MenuContainer
      showMenu={props.showMenu}
      isLarge={props.isLarge}
      isSmall={props.isSmall}
      leftPosition={props.leftPosition}
      topPosition={props.topPosition}
      bottomPosition={props.bottomPosition}
      openTowardUp={props.openTowardUp}
    >
      <CloseableArea
        show={props.showMenu}
        focus
        onClose={() => props.close()}
      />
      <div className="menu-container-wrapper">{props.children}</div>
    </MenuContainer>
  );
};
